import router from '@/router/index';
import {VitalsNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs } = api;
    let here = parent.active;

    here.init
      .to(here.vitals);
    here.vitals
      .to()
      .when(messageIs(ResumeFsm))
      .effect(({context},{vitals})=>{
        context.commit('login/watch/setAllWatches',vitals,{root:true}); //might need to change
        router.push({name:VitalsNavigation})
      });
  }
};